<template>
    <div v-if="loading" class="text-center" style="padding:100px;">
        {{translate('processingMessages.checking')}}
    </div>
    <div v-else>
        <div v-if="errorMessage" class="alert alert-danger">
            {{errorMessage}}
        </div>
    </div>
</template>
<script>
import axios from 'axios';

export default {
    data(){
        return {
            loading: true,
            errorMessage: null
        }
    },
    created(){
        let decodedLink = decodeURIComponent(this.$route.query.t);
        axios.defaults.headers.common['token'] = decodedLink;
        axios.post("/token/refresh", { token: decodedLink })
        .then(x => {
            this.errorMessage = null;
            console.log("Gelen sonuç:", x);
            if(x.data.Success) {
                window.localStorage.setItem('user', JSON.stringify(x.data.Data));
                axios.defaults.headers.common['token'] = x.data.Data.Key;
                this.$root.$data.login = x.data.Data;
                this.$router.push('/' + x.data.Data.Account.Code);
            } else {
                this.errorMessage = x.ErrorMessages;
                this.loading = false;
            }
            console.log('Token geldi: ', axios.defaults.headers.common['token']);
        }).catch(e => {
            this.loading = false;
            console.log('Error:', e);
            axios.defaults.headers.common['token'] = null;
            window.processErrorResponse(e, this);
        })
    }
}
</script>